import { render, staticRenderFns } from "./CorredoresHistorico.vue?vue&type=template&id=46fc7401&"
import script from "./CorredoresHistorico.vue?vue&type=script&lang=js&"
export * from "./CorredoresHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports